<template>
  <BookingsList :query="query" />
</template>

<script lang="ts" setup>
import BookingsList from '../../bookings/bookings-list/BookingsList.vue';
import { computed } from 'vue';
import { FindAllBookingsSort } from '@/entities/bookings/find-all-bookings-sort.enum';
import { Order } from '@/entities/pagination/order.enum';
import { BookingType } from '@/entities/bookings/booking-type.enum';
import type { FindAllBookingsQueryDto } from '@/entities/bookings/booking.entity';

const props = defineProps<{
  userId: string;
}>();

const query = computed<FindAllBookingsQueryDto>(() => ({
  filter: [
    {
      types: [BookingType.CUSTOMER_BOOKING],
      customerIds: [props.userId],
    },
    {
      types: [BookingType.CUSTOMER_BOOKING],
      agencyIds: [props.userId],
    },
  ],
  sort: FindAllBookingsSort.START_DATE,
  order: Order.DESC,
}));
</script>
